// HOOKS
import { useLazyQuery } from "@apollo/client";
import useQuery from "../other/useQuery.other.hook";
import { useState, useEffect } from "react";
// GRAPHQL
import { GET_ASSETS } from "../../graphql/queries/assets/assets.queries";
// UTILS
import convertToyyyyMMddThhmm from "../../utils/conversions/dates/yyyyMMddThhmm.date.conversion.util";

const DEFAULT_QUERY = {
  search: "",
  page: 1,
  limit: 25,
  sort: "-updated_at",
};

const useGetManyAssets = () => {
  const [assets, setAssets] = useState([]);
  const [metaData, setMetaData] = useState({});
  const [assetInput, setAssetInput] = useState({});
  const [getAssetQuery, { loading, error, data }] = useLazyQuery(GET_ASSETS, {
    fetchPolicy: "no-cache",
  });
  const {
    query,
    setQuery,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    handleSort,
  } = useQuery({ defaultQuery: DEFAULT_QUERY });

  const getAssets = async () => {
    try {
      const res = await getAssetQuery({
        variables: { query, asset: assetInput },
      });
      if (res?.data?.assets?.assets)
        setAssets(
          res.data.assets.assets.map((asset) => ({
            ...asset,
            warranty_start_date: convertToyyyyMMddThhmm(
              asset?.warranty_start_date
            ),
            warranty_end_date: convertToyyyyMMddThhmm(asset?.warranty_end_date),
          }))
        );
      if (res?.data?.assets?.metaData) setMetaData(res.data.assets.metaData);
    } catch (error) {
      console.error(`Error getting asset: ${error?.message}`);
      alert(`Error getting asset: ${error?.message}`);
    }
  };

  // Get assets on query or assetInput change
  useEffect(() => {
    getAssets();
  }, [query, assetInput]);

  return {
    getAssets,
    assets,
    setAssets,
    metaData,
    setMetaData,
    assetInput,
    setAssetInput,
    query,
    setQuery,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    handleSort,
    loading,
    error,
  };
};

export default useGetManyAssets;
